import { useMutation, useQueryClient } from '@tanstack/react-query';
import { terminologyApi } from '../api/terminologyApi';
import type { ForbiddenWordUpsertRequest } from '../types/terminology';

/**
 * POST /api/eraf/terminology/forbidden-words (create)
 * PUT  /api/eraf/terminology/forbidden-words/:id (update)
 */
export function useUpsertForbiddenWord() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, body }: { id?: number; body: ForbiddenWordUpsertRequest }) =>
      id !== undefined
        ? terminologyApi.updateForbiddenWord(id, body)
        : terminologyApi.createForbiddenWord(body),
    onSuccess: (_data, variables) => {
      void queryClient.invalidateQueries({
        queryKey: ['terminology', 'forbidden-words', 'list'],
      });
      if (variables.id !== undefined) {
        void queryClient.invalidateQueries({
          queryKey: ['terminology', 'forbidden-words', 'detail', variables.id],
        });
      }
      void queryClient.invalidateQueries({ queryKey: ['terminology', 'summary'] });
    },
  });
}
